"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const Bonus_vue_1 = __importDefault(require("@/client/components/Bonus.vue"));
const BoardSpaceTile_vue_1 = __importDefault(require("@/client/components/board/BoardSpaceTile.vue"));
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
const spaces_1 = require("@/common/boards/spaces");
exports.default = (0, vue_1.defineComponent)({
    name: 'MoonSpace',
    props: {
        space: {
            type: Object,
            required: true,
        },
        text: {
            type: String,
            required: false,
        },
        tileView: {
            type: String,
            default: 'show',
        },
    },
    components: {
        Bonus: Bonus_vue_1.default,
        'board-space-tile': BoardSpaceTile_vue_1.default,
    },
    computed: {
        mainClass() {
            let css = 'board-space moon-space-' + this.space.id.toString();
            css += ' board-space-selectable';
            if (this.space.spaceType === 'lunar_mine') {
                css += ' moon-space-type-mine';
            }
            else {
                css += ' moon-space-type-other';
            }
            return css;
        },
        playerColorCss() {
            if (this.space?.color === undefined) {
                return '';
            }
            const css = 'board-cube board-cube--' + this.space.color;
            return (0, PreferencesManager_1.getPreferences)().symbol_overlay ? css + ' overlay' : css;
        },
        coOwnerColorCss() {
            if (this.space?.coOwner === undefined) {
                return '';
            }
            const css = 'board-cube-coOwner board-cube--' + this.space.coOwner;
            return (0, PreferencesManager_1.getPreferences)().symbol_overlay ? css + ' overlay' : css;
        },
        getSpaceName() {
            return spaces_1.getSpaceName;
        },
    },
});
